import { useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let id = localStorage.getItem("watchlist_session");
  if (!id) {
    id = "s_" + Math.random().toString(36).slice(2, 12);
    localStorage.setItem("watchlist_session", id);
  }
  return id;
}

export function useWatchlist() {
  const [tickers, setTickers] = useState([]);
  const sessionId = getSessionId();

  const fetchWatchlist = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/watchlist/${sessionId}`);
      setTickers(res.data.tickers || []);
    } catch {
      // Fallback to localStorage
      const stored = localStorage.getItem("watchlist_tickers");
      if (stored) setTickers(JSON.parse(stored));
    }
  }, [sessionId]);

  useEffect(() => {
    fetchWatchlist();
  }, [fetchWatchlist]);

  const addTicker = useCallback(async (ticker) => {
    try {
      const res = await axios.post(`${API}/watchlist/${sessionId}/add?ticker=${ticker}`);
      setTickers(res.data.tickers || []);
      localStorage.setItem("watchlist_tickers", JSON.stringify(res.data.tickers || []));
    } catch {
      setTickers((prev) => {
        const updated = [...new Set([...prev, ticker])];
        localStorage.setItem("watchlist_tickers", JSON.stringify(updated));
        return updated;
      });
    }
  }, [sessionId]);

  const removeTicker = useCallback(async (ticker) => {
    try {
      const res = await axios.post(`${API}/watchlist/${sessionId}/remove?ticker=${ticker}`);
      setTickers(res.data.tickers || []);
      localStorage.setItem("watchlist_tickers", JSON.stringify(res.data.tickers || []));
    } catch {
      setTickers((prev) => {
        const updated = prev.filter((t) => t !== ticker);
        localStorage.setItem("watchlist_tickers", JSON.stringify(updated));
        return updated;
      });
    }
  }, [sessionId]);

  const isWatched = useCallback((ticker) => tickers.includes(ticker), [tickers]);

  return { tickers, addTicker, removeTicker, isWatched, sessionId };
}
